import Eventable from 'utils/eventable';

/**
 * Parse SVP Player events and tailor data to pulse requirements
 *
 * Available events: Play, Pause, Stop, Watch
 */
class AdEvents extends Eventable {
    constructor(player) {
        super();
        this.player = player;
        this.adData = {};
        this.beforeUnload = ['beforeunload', this.onAdSlotComplete.bind(this), true];

        this.listenTo(this.player, 'adSlotStart', this.onAdSlotStart, this);
        this.listenTo(this.player, 'adStarted', this.onAdStarted, this);
        this.listenTo(this.player, 'adProgress', this.onAdProgress, this);
        this.listenTo(this.player, 'adSlotComplete', this.onAdSlotComplete, this);

        this.listenTo(this.player, 'adPause', this.onAdPause, this);
        this.listenTo(this.player, 'adPlay', this.onAdPlay, this);

        this.listenTo(this.player, 'PausePlugin:adVisible', this.onPauseAdVisible, this);

        this.listenTo(this.player, 'ready', this.onReady, this);
    }

    onReady() {
        this.listenTo(this.player.model.player, 'adImpression', (adData) => {
            Object.assign(this.adData, {
                duration: Math.round(adData.duration)
            });
        });
    }

    onAdSlotStart(slotData) {
        window.addEventListener(...this.beforeUnload);

        Object.assign(this.adData, {
            type: slotData.position
        });
    }

    onAdStarted() {
        Object.assign(this.adData, {
            start: true
        });

        this.listenToOnce(this.player.model.player, 'adMeta', (adData) => {
            let adId = null;

            try {
                const adXml = adData.response.querySelectorAll('Ad')[adData.sequence - 1];
                adId = adXml.id;
            } catch (e) {
                // could not find Ad element
            }

            Object.assign(this.adData, {
                id: adId,
                sequence: adData.sequence,
                count: adData.podcount,
                position: 0
            });
        });
    }

    onAdProgress(time) {
        const position = Math.floor(time);
        const previousPosition = this.adData.position;

        Object.assign(this.adData, {
            position
        });

        if (previousPosition !== position) {
            this.trigger('Watch', this.adData);
        }
    }

    onAdSlotComplete() {
        window.removeEventListener(...this.beforeUnload);

        // prevent cleaning object by reference
        this.trigger('Stop', Object.assign({}, this.adData));
        this.adData = {};
    }

    onAdPlay() {
        this.trigger('Play', this.adData);

        // start indicates first play of ad
        this.adData.start = false;
    }

    onAdPause() {
        this.trigger('Pause', this.adData);
    }

    onPauseAdVisible(data) {
        this.trigger('View', {
            id: data.creativeId,
            type: 'Pausead'
        });
    }

    destroy() {
        window.removeEventListener(...this.beforeUnload);
        this.stopListening();
    }
}

export default AdEvents;
